'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { useRouter, useSearchParams } from 'next/navigation';
import { ArrowDownAZ, ArrowUpAZ } from 'lucide-react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { ProductsSortByEnum } from '@/types/product';
import { SortEnum } from '@/enums';
type PropsType = {
  // When provided, the selector is controlled and reports changes via onChange instead of
  // navigating (used by the client-side products browser). Otherwise, it falls back to URL-driven
  // navigation for server-rendered usages.
  sortBy?: ProductsSortByEnum;
  sort?: SortEnum;
  onChange?: (sortBy: ProductsSortByEnum, sort: SortEnum) => void;
};
const ProductsSortSelector = t0 => {
  const $ = _c(86);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    sortBy,
    sort,
    onChange
  } = t1;
  const t = useTranslations();
  const router = useRouter();
  const searchParams = useSearchParams();
  let t2;
  if ($[2] !== searchParams || $[3] !== sortBy) {
    t2 = sortBy ?? searchParams.get("sortBy") as ProductsSortByEnum ?? ProductsSortByEnum.CREATED_AT;
    $[2] = searchParams;
    $[3] = sortBy;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const currentSortBy = t2;
  let t3;
  if ($[5] !== searchParams || $[6] !== sort) {
    t3 = sort ?? searchParams.get("sort") as SortEnum ?? SortEnum.DESC;
    $[5] = searchParams;
    $[6] = sort;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const currentSort = t3;
  const currentValue = `${currentSortBy}-${currentSort}`;
  let t4;
  if ($[8] !== onChange || $[9] !== router || $[10] !== searchParams) {
    t4 = value => {
      const [nextSortBy, nextSort] = value.split("-") as [ProductsSortByEnum, SortEnum];
      if (onChange) {
        onChange(nextSortBy, nextSort);
        return;
      }
      const params = new URLSearchParams(searchParams.toString());
      params.set("sortBy", nextSortBy);
      params.set("sort", nextSort);
      params.delete("page");
      router.push(`?${params.toString()}`);
    };
    $[8] = onChange;
    $[9] = router;
    $[10] = searchParams;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const handleSortChange = t4;
  let t5;
  if ($[12] !== t) {
    t5 = t("sort_by_created_at");
    $[12] = t;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t) {
    t6 = t("sort_desc");
    $[14] = t;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  const t7 = `${t5} (${t6})`;
  let t8;
  if ($[16] !== t7) {
    t8 = {
      value: `${ProductsSortByEnum.CREATED_AT}-${SortEnum.DESC}`,
      label: t7
    };
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t) {
    t9 = t("sort_by_created_at");
    $[18] = t;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t) {
    t10 = t("sort_asc");
    $[20] = t;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  const t11 = `${t9} (${t10})`;
  let t12;
  if ($[22] !== t11) {
    t12 = {
      value: `${ProductsSortByEnum.CREATED_AT}-${SortEnum.ASC}`,
      label: t11
    };
    $[22] = t11;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== t) {
    t13 = t("sort_by_title");
    $[24] = t;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== t) {
    t14 = t("sort_asc");
    $[26] = t;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  const t15 = `${t13} (${t14})`;
  let t16;
  if ($[28] !== t15) {
    t16 = {
      value: `${ProductsSortByEnum.TITLE}-${SortEnum.ASC}`,
      label: t15
    };
    $[28] = t15;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  let t17;
  if ($[30] !== t) {
    t17 = t("sort_by_title");
    $[30] = t;
    $[31] = t17;
  } else {
    t17 = $[31];
  }
  let t18;
  if ($[32] !== t) {
    t18 = t("sort_desc");
    $[32] = t;
    $[33] = t18;
  } else {
    t18 = $[33];
  }
  const t19 = `${t17} (${t18})`;
  let t20;
  if ($[34] !== t19) {
    t20 = {
      value: `${ProductsSortByEnum.TITLE}-${SortEnum.DESC}`,
      label: t19
    };
    $[34] = t19;
    $[35] = t20;
  } else {
    t20 = $[35];
  }
  let t21;
  if ($[36] !== t) {
    t21 = t("sort_by_code");
    $[36] = t;
    $[37] = t21;
  } else {
    t21 = $[37];
  }
  let t22;
  if ($[38] !== t) {
    t22 = t("sort_asc");
    $[38] = t;
    $[39] = t22;
  } else {
    t22 = $[39];
  }
  const t23 = `${t21} (${t22})`;
  let t24;
  if ($[40] !== t23) {
    t24 = {
      value: `${ProductsSortByEnum.CODE}-${SortEnum.ASC}`,
      label: t23
    };
    $[40] = t23;
    $[41] = t24;
  } else {
    t24 = $[41];
  }
  let t25;
  if ($[42] !== t) {
    t25 = t("sort_by_code");
    $[42] = t;
    $[43] = t25;
  } else {
    t25 = $[43];
  }
  let t26;
  if ($[44] !== t) {
    t26 = t("sort_desc");
    $[44] = t;
    $[45] = t26;
  } else {
    t26 = $[45];
  }
  const t27 = `${t25} (${t26})`;
  let t28;
  if ($[46] !== t27) {
    t28 = {
      value: `${ProductsSortByEnum.CODE}-${SortEnum.DESC}`,
      label: t27
    };
    $[46] = t27;
    $[47] = t28;
  } else {
    t28 = $[47];
  }
  let t29;
  if ($[48] !== t) {
    t29 = t("sort_by_price");
    $[48] = t;
    $[49] = t29;
  } else {
    t29 = $[49];
  }
  let t30;
  if ($[50] !== t) {
    t30 = t("sort_asc");
    $[50] = t;
    $[51] = t30;
  } else {
    t30 = $[51];
  }
  const t31 = `${t29} (${t30})`;
  let t32;
  if ($[52] !== t31) {
    t32 = {
      value: `${ProductsSortByEnum.PRICE}-${SortEnum.ASC}`,
      label: t31
    };
    $[52] = t31;
    $[53] = t32;
  } else {
    t32 = $[53];
  }
  let t33;
  if ($[54] !== t) {
    t33 = t("sort_by_price");
    $[54] = t;
    $[55] = t33;
  } else {
    t33 = $[55];
  }
  let t34;
  if ($[56] !== t) {
    t34 = t("sort_desc");
    $[56] = t;
    $[57] = t34;
  } else {
    t34 = $[57];
  }
  const t35 = `${t33} (${t34})`;
  let t36;
  if ($[58] !== t35) {
    t36 = {
      value: `${ProductsSortByEnum.PRICE}-${SortEnum.DESC}`,
      label: t35
    };
    $[58] = t35;
    $[59] = t36;
  } else {
    t36 = $[59];
  }
  let t37;
  if ($[60] !== t12 || $[61] !== t16 || $[62] !== t20 || $[63] !== t24 || $[64] !== t28 || $[65] !== t32 || $[66] !== t36 || $[67] !== t8) {
    t37 = [t8, t12, t16, t20, t24, t28, t32, t36];
    $[60] = t12;
    $[61] = t16;
    $[62] = t20;
    $[63] = t24;
    $[64] = t28;
    $[65] = t32;
    $[66] = t36;
    $[67] = t8;
    $[68] = t37;
  } else {
    t37 = $[68];
  }
  const sortOptions = t37;
  const currentSortLabel = sortOptions.find(opt => opt.value === currentValue)?.label;
  let t38;
  if ($[69] !== currentSort) {
    t38 = currentSort === SortEnum.ASC ? <ArrowUpAZ className="h-4 w-4 shrink-0" /> : <ArrowDownAZ className="h-4 w-4 shrink-0" />;
    $[69] = currentSort;
    $[70] = t38;
  } else {
    t38 = $[70];
  }
  let t39;
  if ($[71] !== currentSortLabel || $[72] !== t) {
    t39 = currentSortLabel || t("sort_by");
    $[71] = currentSortLabel;
    $[72] = t;
    $[73] = t39;
  } else {
    t39 = $[73];
  }
  let t40;
  if ($[74] !== t39) {
    t40 = <SelectValue>{t39}</SelectValue>;
    $[74] = t39;
    $[75] = t40;
  } else {
    t40 = $[75];
  }
  let t41;
  if ($[76] !== t38 || $[77] !== t40) {
    t41 = <SelectTrigger><div className="flex items-center gap-2">{t38}{t40}</div></SelectTrigger>;
    $[76] = t38;
    $[77] = t40;
    $[78] = t41;
  } else {
    t41 = $[78];
  }
  let t42;
  if ($[79] !== sortOptions) {
    t42 = <SelectContent>{sortOptions.map(_temp)}</SelectContent>;
    $[79] = sortOptions;
    $[80] = t42;
  } else {
    t42 = $[80];
  }
  let t43;
  if ($[81] !== currentValue || $[82] !== handleSortChange || $[83] !== t41 || $[84] !== t42) {
    t43 = <div className="flex items-center gap-2"><Select value={currentValue} onValueChange={handleSortChange}>{t41}{t42}</Select></div>;
    $[81] = currentValue;
    $[82] = handleSortChange;
    $[83] = t41;
    $[84] = t42;
    $[85] = t43;
  } else {
    t43 = $[85];
  }
  return t43;
};
export default ProductsSortSelector;
function _temp(option) {
  return <SelectItem key={option.value} value={option.value}>{option.label}</SelectItem>;
}